export default __webpack_public_path__ + "static/media/MercadoPago.109bec28.svg";